import React from "react";
function Prize () {
    return (

        <h2>Prize</h2>
    )
    
}
export default Prize;